import React, { useEffect, useRef} from "react";
import CssTransition from "../../../component/layout/css-transition";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import InputField from "../../../component/input-field";
import { useDispatch, useSelector } from "react-redux";
import { SET_STAKEHOLDER_DETAILS } from "../../../redux/constants";

export default function AddAndUpdateStakeholder({
  id,
  modalOpen,
  setModalOpen,
  _handleSubmit,
}) {
  const modalContent = useRef(null);
  const dispatch = useDispatch();
  const { stakeholder_details } = useSelector(state => state.stakeholder);

  const schema = yup.object({
    stakeholder_category_name: yup
      .string()
      .required("Stakeholder name is required.")
      .max(
        50,
        "Stakeholder name have reached maximum limit of characters allowed."
      ),
  });

  const { control, setValue, handleSubmit, reset } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const defaultValues = {
    stakeholder_category_name: "",
  };

  useEffect(() => {
    if(stakeholder_details){
      setValue("stakeholder_category_name", stakeholder_details.stakeholder_category_name)
    }
  }, [stakeholder_details]);

  const onSubmit = (data) => {
    let payload = {
      stakeholder_category_name: data.stakeholder_category_name,
    };
    if(stakeholder_details) payload['stakeholder_category_id'] = stakeholder_details.stakeholder_category_id;
    _handleSubmit(payload);
    reset(defaultValues);
  };
  
  return (
    <>
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={modalOpen}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        id={id}
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={modalOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div
          ref={modalContent}
          className="bg-white w-full overflow-auto max-w-lg max-h-full rounded shadow-lg flex flex-col"
        >
          <div class="py-6 px-6 ">
            <h3 class="mb-8 text-xl font-medium text-gray-900 flex justify-center">
              {`${stakeholder_details ? "Update" : "Add"} Stockholder`}
            </h3>
            <form class="space-y-6" onSubmit={handleSubmit(onSubmit)}>
              <div class="flex flex-wrap -mx-3 mb-6">
                <div class="w-full px-3 mb-6 md:mb-0">
                  <Controller
                    name="stakeholder_category_name"
                    defaultValue={defaultValues.stakeholder_category_name}
                    control={control}
                    render={({ field, formState }) => (
                      <div>
                        <InputField
                          {...field}
                          type="text"
                          label="Stockholder Name"
                          placeholder="Enter Stakeholder Name"
                          error={
                            Boolean(formState.errors?.stakeholder_category_name)
                              ? formState.errors?.stakeholder_category_name
                                  .message
                              : null
                          }
                          required
                        />
                      </div>
                    )}
                  />
                </div>
              </div>
              <div class="flex justify-end space-x-2">
                <button
                  type="button"
                  className="btn bg-slate-100 border-slate-200 hover:border-slate-300 text-slate-600"
                  onClick={() => {
                    dispatch({type: SET_STAKEHOLDER_DETAILS, payload: null});
                    setModalOpen(false);
                    reset(defaultValues);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
                  type="Submit"
                >
                  {`${stakeholder_details ? "Update" : "Add"}`}
                </button>
              </div>
            </form>
          </div>
        </div>
      </CssTransition>
    </>
  );
}
